module.exports = __webpack_public_path__ + "static/media/Damaged.55a7dbac.png";